define([
    "./monitoringLGPDModule",
    "./monitoringLgpdApi",
    "./monitoringLGPDConfiguration"
], function () {
});